import styled from "styled-components";

export const SelectContainer = styled.div`
	display: flex;
	flex-direction: column;
`;